import React, { useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import {
  FaTimes,
} from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import "../css/Admin_css/admin-customize.css";

const ATTENDANCE_OPTIONS = [
  { code: "P", label: "Present", tone: "p" },
  { code: "A", label: "Absent", tone: "a" },
  { code: "HD", label: "Half Day", tone: "hd" },
  { code: "L", label: "Leave", tone: "l" },
  { code: "LA", label: "Late Attendance", tone: "la" },
];

const ACCENT = COLORS.primary_color_shade6 || "#039BE5";
const MODAL_RADIUS = 20;

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

function staffInitials(name) {
  const parts = String(name || "?").trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return (parts[0]?.[0] || "?").toUpperCase();
}

const MODAL_STYLES = `
  .mdl-record-staff-att.modal-dialog {
    max-width: 440px;
    margin: 0.75rem auto 1.25rem;
  }
  .mdl-record-staff-att .modal-content {
    border: none;
    border-radius: ${MODAL_RADIUS}px;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(15, 23, 42, 0.2);
  }
  .mdl-record-staff-att .modal-body {
    padding: 0;
  }
  .rsa-hero {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 18px 16px 16px;
    background: linear-gradient(135deg, ${ACCENT} 0%, ${COLORS.primary_color_shade7 || "#0288D1"} 100%);
    color: #fff;
  }
  .rsa-hero__photo,
  .rsa-hero__avatar {
    width: 52px;
    height: 52px;
    border-radius: 16px;
    object-fit: cover;
    flex-shrink: 0;
    background: rgba(255,255,255,0.18);
    border: 2px solid rgba(255,255,255,0.45);
  }
  .rsa-hero__avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 800;
  }
  .rsa-hero__meta {
    min-width: 0;
    flex: 1;
  }
  .rsa-hero__meta strong {
    display: block;
    font-size: 16px;
    font-weight: 800;
    line-height: 1.2;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .rsa-hero__meta span {
    display: block;
    margin-top: 4px;
    font-size: 12px;
    font-weight: 600;
    opacity: 0.9;
  }
  .rsa-hero__close {
    width: 34px;
    height: 34px;
    border: 0;
    border-radius: 10px;
    background: rgba(255,255,255,0.16);
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .rsa-body {
    padding: 16px;
  }
  .rsa-hint {
    margin: 0 0 12px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #64748b;
  }
  .rsa-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .rsa-option {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 64px;
    padding: 10px 12px;
    border-radius: 14px;
    border: 1.5px solid #e2e8f0;
    background: #f8fafc;
    text-align: left;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
  }
  .rsa-option:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 16px rgba(15, 23, 42, 0.08);
  }
  .rsa-option__code {
    width: 36px;
    height: 36px;
    border-radius: 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 800;
    color: #fff;
    flex-shrink: 0;
  }
  .rsa-option__label {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }
  .rsa-option__label b {
    font-size: 13px;
    font-weight: 800;
    color: #0f172a;
    line-height: 1.2;
  }
  .rsa-option__label small {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
  }
  .rsa-option.is-p .rsa-option__code { background: #059669; }
  .rsa-option.is-a .rsa-option__code { background: #dc2626; }
  .rsa-option.is-hd .rsa-option__code { background: #7c3aed; }
  .rsa-option.is-l .rsa-option__code { background: #d97706; }
  .rsa-option.is-la .rsa-option__code { background: #e11d48; }
  .rsa-option.is-on.is-p {
    border-color: #059669;
    background: #ecfdf5;
  }
  .rsa-option.is-on.is-a {
    border-color: #dc2626;
    background: #fef2f2;
  }
  .rsa-option.is-on.is-hd {
    border-color: #7c3aed;
    background: #f5f3ff;
  }
  .rsa-option.is-on.is-l {
    border-color: #d97706;
    background: #fffbeb;
  }
  .rsa-option.is-on.is-la {
    border-color: #e11d48;
    background: #fff1f2;
  }
  .rsa-option.is-on {
    box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);
  }
  .rsa-foot {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 0 16px 16px;
  }
  .rsa-btn {
    min-height: 40px;
    padding: 0 16px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 800;
    cursor: pointer;
  }
  .rsa-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }
  .rsa-btn--ghost {
    border: 1px solid #e2e8f0;
    background: #fff;
    color: #475569;
  }
  .rsa-btn--save {
    border: 0;
    background: linear-gradient(135deg, #0388d1 0%, #03a9f4 100%);
    color: #fff;
    box-shadow: 0 8px 16px rgba(3, 169, 244, 0.24);
  }
  .rsa-loader {
    padding: 36px 16px;
  }
  @media (max-width: 420px) {
    .rsa-grid {
      grid-template-columns: 1fr;
    }
  }
`;

const MdlRecordStaffAttendance = ({
  staff,
  attendanceDate,
  attendanceDateDisplay,
  actionClose,
  actionSaved,
}) => {
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(true);
  const [status, setStatus] = useState("");

  const handleClose = () => {
    if (loading) return;
    setShow(false);
    if (typeof actionClose === "function") actionClose();
  };

  const handleSubmit = async () => {
    if (!status) {
      myToast.notify_warning("Select Present, Absent, Half Day, Leave or Late Attendance.");
      return;
    }

    const schoolCode = SessionManager.getSchoolCode();
    const authorizedId = SessionManager.getStaffDetails()?.staff_id;
    if (!schoolCode || !authorizedId || !staff?.staff_id || !attendanceDate) {
      myToast.notify_warning("Missing school, staff or date to record attendance.");
      return;
    }

    setLoading(true);
    try {
      const now = new Date();
      const hh = String(now.getHours()).padStart(2, "0");
      const mm = String(now.getMinutes()).padStart(2, "0");
      const ss = String(now.getSeconds()).padStart(2, "0");
      const attendanceTime = `${hh}:${mm}:${ss}`;
      const attendanceDateTime = `${attendanceDate} ${attendanceTime}`;

      const response = await axios.get(`${API_BASE()}AddStaffAttendance.php`, {
        params: {
          school_code: schoolCode,
          authorized_staff_id: authorizedId,
          staff_id: staff.staff_id,
          attendance_date: attendanceDate,
          attendance_time: attendanceTime,
          attendance_datetime: attendanceDateTime,
          attendance: status,
        },
      });

      if (response.data?.api_status === "OK") {
        myToast.notify_success("Attendance recorded.");
        setShow(false);
        if (typeof actionSaved === "function") actionSaved();
        else if (typeof actionClose === "function") actionClose();
      } else {
        myToast.notify_warning(
          response.data?.api_remark || "Could not record attendance."
        );
      }
    } catch (err) {
      console.error("Record staff attendance error:", err);
      myToast.notify_error("An error occurred while recording attendance.");
    } finally {
      setLoading(false);
    }
  };

  const selected = ATTENDANCE_OPTIONS.find((opt) => opt.code === status);
  const saveLabel = selected ? `Save ${selected.code}` : "Save";

  return (
    <>
      <style>{MODAL_STYLES}</style>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        dialogClassName="mdl-record-staff-att"
        centered
      >
        <Modal.Body>
          <header className="rsa-hero">
            {staff?.staff_image_path ? (
              <img
                className="rsa-hero__photo"
                src={staff.staff_image_path}
                alt=""
                onError={(event) => {
                  event.currentTarget.style.visibility = "hidden";
                  const fallback = event.currentTarget.nextElementSibling;
                  if (fallback) fallback.style.display = "inline-flex";
                }}
              />
            ) : null}
            <span
              className="rsa-hero__avatar"
              style={staff?.staff_image_path ? { display: "none" } : undefined}
            >
              {staffInitials(staff?.staff_name)}
            </span>
            <div className="rsa-hero__meta">
              <strong>{staff?.staff_name || staff?.staff_id}</strong>
              <span>
                {staff?.staff_id ? `${staff.staff_id} · ` : ""}
                {attendanceDateDisplay}
              </span>
            </div>
            <button
              type="button"
              className="rsa-hero__close"
              onClick={handleClose}
              disabled={loading}
              aria-label="Close"
            >
              <FaTimes />
            </button>
          </header>

          {loading ? (
            <div className="rsa-loader">
              <MyLoader />
            </div>
          ) : (
            <div className="rsa-body">
              <p className="rsa-hint">Select status</p>
              <div className="rsa-grid" role="group" aria-label="Attendance status">
                {ATTENDANCE_OPTIONS.map((opt) => (
                  <button
                    key={opt.code}
                    type="button"
                    className={`rsa-option is-${opt.tone}${
                      status === opt.code ? " is-on" : ""
                    }`}
                    onClick={() => setStatus(opt.code)}
                  >
                    <span className="rsa-option__code">{opt.code}</span>
                    <span className="rsa-option__label">
                      <b>{opt.label}</b>
                      <small>{opt.code}</small>
                    </span>
                  </button>
                ))}
              </div>
            </div>
          )}

          <div className="rsa-foot">
            <button
              type="button"
              className="rsa-btn rsa-btn--ghost"
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="rsa-btn rsa-btn--save"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Saving…" : saveLabel}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default MdlRecordStaffAttendance;
